__turbopack_context__.v({
  "container": "Overview-module__ojNhdG__container",
  "grid": "Overview-module__ojNhdG__grid",
  "header": "Overview-module__ojNhdG__header",
  "title": "Overview-module__ojNhdG__title",
});
